import React from 'react';
import { css } from 'react-emotion';
import { fonts } from '@peachjar/components';

const styles = {
  container: css({
    fontFamily: fonts.ProximaNovaA,
    paddingTop: '1.5rem',
  }),
  subHeading: css({
    fontSize: '1.1rem',
    paddingBottom: '0.5rem',
  }),
  details: css({
    paddingTop: '1rem',
    fontSize: '0.8rem',
  }),
  closeBrowserNote: css({
    fontSize: '0.8rem',
    paddingTop: '2rem',
  }),
};

const InProgressMessage = ({ task, status, isAssigneePresent, assignee }) => {
  // this is the case where the registrant is on the page and
  // the assignee has sent the check already
  if (assignee.firstName && !isAssigneePresent) {
    return <div className={styles.container}>The check is on its way!</div>;
  }

  return (
    <div className={styles.container}>
      <div className={styles.subHeading}>
        {"If you haven't yet, send a check to:"}
      </div>
      <div className={styles.details}>
        Peachjar<br />
        13290 Evening Creek Dr #200<br />
        San Diego, CA 92128<br />
      </div>

      <div className={styles.details}>
        Please send payment within 30 days. We will send you an email with a
        link to your invoice once the check has been received.
      </div>

      {isAssigneePresent && (
        <div className={styles.closeBrowserNote}>
          You may now close this browser window.
        </div>
      )}
    </div>
  );
};

export default InProgressMessage;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/InProgressMessage.jsx